<div class="modal-header">
  <h4 class="modal-title">
    <i class="bi bi-shield-lock me-2"></i>
    @if (showFullPolicy) {
    Datenschutzerklärung & Nutzungsbedingungen
    } @else {
    Aktualisierte Rechtliche Dokumente
    }
  </h4>
  @if (showFullPolicy) {
  <button type="button" class="btn-close" (click)="backToSummary()" aria-label="Zurück"></button>
  }
</div>

<div class="modal-body">
  @if (!showFullPolicy) {
  <!-- Summary View -->
  <div class="alert alert-info">
    <i class="bi bi-gift me-2"></i>
    <strong>Kleines Dankeschön für unsere frühen Nutzer!</strong>
  </div>

  <p>
    Vielen Dank, dass du KlausurenKIste von Anfang an nutzt und uns mit deinem wertvollen Feedback geholfen hast, die
    Plattform besser zu machen!
  </p>

  <p>
    Mit dem heutigen Update führen wir unser neues <strong>KlausurenKIste Plus</strong> Abo-Modell ein, damit wir die
    laufenden Server- und KI-Kosten decken und die App für dich weiterentwickeln können. Wir würden uns riesig freuen,
    wenn du uns auf diesem Weg unterstützt!
  </p>

  <div class="updates-list">
    <h5>Was das für dich bedeutet:</h5>
    <ul>
      <li>
        <strong>Spannende Updates geplant:</strong> Freu dich in Zukunft auf noch mehr neue Features, Fall-Pakete und
        gezielte Verbesserungen.
      </li>
      <li>
        <strong>Rechtliche Eckdaten:</strong> Um das neue Abo-Modell und unseren Zahlungsdienstleister (Stripe)
        rechtssicher abzubilden, haben wir unsere <a href="javascript:void(0)" (click)="showFullPrivacyPolicy()"
          class="fw-bold">Datenschutzerklärung und Nutzungsbedingungen</a> entsprechend aktualisiert.
      </li>
    </ul>
  </div>

  <div class="privacy-notice mt-3">
    <p>
      <strong>Deine Rechte bleiben unverändert:</strong>
    </p>
    <ul class="small">
      <li>Recht auf Auskunft, Berichtigung und Löschung</li>
      <li>Alle Feedback- und Bewertungsdaten sind freiwillig</li>
      <li>Daten werden nur in Deutschland/Finnland gespeichert (Hetzner)</li>
    </ul>
  </div>

  <div class="mt-3">
    <p class="text-muted small">
      Mit dem Klick auf "Akzeptieren & Fortfahren" stimmst du den aktualisierten Dokumenten zu und kannst direkt
      weitermachen.
    </p>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">
    {{ errorMessage }}
  </div>
  } @else {
  <!-- Full Policy View -->
  <div class="full-policy-content" style="max-height: 60vh; overflow-y: auto;">
    <markdown [data]="fullPolicyContent"></markdown>
  </div>
  }
</div>

<div class="modal-footer">
  @if (showFullPolicy) {
  <button type="button" class="btn btn-outline-secondary" (click)="backToSummary()">
    <i class="bi bi-arrow-left me-1"></i> Zurück zur Zusammenfassung
  </button>
  } @else {
  <button type="button" class="btn btn-outline-secondary" (click)="decline()" [disabled]="isLoading">
    Ablehnen & Abmelden
  </button>
  <button type="button" class="btn btn-primary" (click)="acceptPrivacyUpdate()" [disabled]="isLoading">
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
    Akzeptieren & Fortfahren
  </button>
  }
</div>